import { HomeView } from "./home-view";
import { StudioView } from "./studio-view";
import { ClientProviders } from "@/client-providers";
import { imagineRoutingStore } from "@/wrapper/imagine-routing.store";
import { useImagineTheme } from "@/stores/imagine-config.store";
import "../../globals.css";
import { ImagineChatProvider } from "@/providers/imagine-chat-provider";
import { MessageHistoryProvider } from "@/providers/message-history-provider";
import { ProjectRealtimeProvider } from "@/providers/project-realtime-provider";
import { ErrorBoundary } from "@/components/error-boundary";

export const WEB_COMPONENT_PORTAL_ID = "imagine-portal";

export function ImagineWebComponentsWrapper() {
  const currentRoute = imagineRoutingStore.use.currentRoute();
  const initialized = imagineRoutingStore.use.initialized();
  const theme = useImagineTheme();

  if (!initialized) {
    return null;
  }

  const renderCurrentRoute = () => {
    if (!currentRoute) {
      return null;
    }

    switch (currentRoute.id) {
      case "home":
        return <HomeView key="home" />;
      case "view":
        return (
          <MessageHistoryProvider
            key={`view-${currentRoute.props.projectId}`}
            projectId={currentRoute.props.projectId}
            disableMessageHistory={true}
          >
            <StudioView
              projectId={currentRoute.props.projectId}
              region={currentRoute.props.region}
              readonly={true}
              isGeneratingNewProject={false}
            />
          </MessageHistoryProvider>
        );
      case "project":
        return (
          <ProjectRealtimeProvider projectId={currentRoute.props.projectId}>
            <MessageHistoryProvider
              projectId={currentRoute.props.projectId}
              skipFetchingHistory={Boolean(
                currentRoute.props.isGeneratingNewProject,
              )}
            >
              <StudioView
                projectId={currentRoute.props.projectId}
                region={currentRoute.props.region}
                readonly={false}
                isGeneratingNewProject={Boolean(
                  currentRoute.props.isGeneratingNewProject,
                )}
              />
            </MessageHistoryProvider>
          </ProjectRealtimeProvider>
        );
      default:
        return null;
    }
  };

  const routeContent = renderCurrentRoute();

  return (
    <ErrorBoundary>
      <main className={`h-full overflow-auto overscroll-none ${theme}`}>
        <ClientProviders>
          <div id={WEB_COMPONENT_PORTAL_ID} />
          <ImagineChatProvider>{routeContent}</ImagineChatProvider>
        </ClientProviders>
      </main>
    </ErrorBoundary>
  );
}
